
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/niigata",
      function () {
        return require("private-next-pages/niigata/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/niigata"])
      });
    }
  